import {React, DomeRouter } from '@lexriver/dome'
import { EnumIconNames } from '../enums/EnumIconNames';
import { Button } from './form/Button';

export const ButtonBack = (attrs:{text:string}, children) => {
    return <Button iconName={EnumIconNames.LeftBig} onClick={() => history.go(-1)} text={attrs.text}></Button>
}